/**
 * Corporate Professional Theme
 * Enhanced professional theme with vibrant colors while maintaining professionalism
 * Updated: December 2025 - Made more vibrant and engaging
 */

export const corporateProfessionalTheme = {
  theme_name: 'Corporate Professional',
  theme_description:
    'Enhanced professional dashboard with vibrant colors and modern design - maintains professionalism with added visual interest',
  vibe: 'Clean & Professional',

  // Colors - Dashboard original colors from image
  primary_color: '#2A60FF', // Bright blue - Template Overview card
  secondary_color: '#2563EB', // Modern blue - Avg Execution Time card
  accent_color: '#3B82F6', // Vibrant blue accent
  background_color: '#F5F7FA', // Soft modern background
  surface_color: '#FFFFFF', // Pure white for cards - clean contrast
  sidebar_background: '#FFFFFF', // White sidebar background
  sidebar_text: '#1A1A1A', // Rich dark text for better contrast
  text_color: '#1A1A1A', // Primary text tier - rich dark for readability
  text_secondary: '#64748B', // Modern slate gray for secondary text
  text_muted: '#94A3B8', // Muted text tier
  text_disabled: '#CBD5E1', // Disabled text tier
  divider_color: '#E2E8F0', // Light divider

  // Semantic Status Colors - Dashboard original colors from image
  success_color: '#2AC460', // Vibrant green - Completed Executions card
  error_color: '#EF4444', // Modern red - vibrant for destructive actions
  warning_color: '#FFA02A', // Bright orange - Total Cost card
  info_color: '#2AC0C4', // Teal/Cyan - Success Rate card

  // Typography - Enhanced modern sans-serif
  font_family: "'Inter', 'Helvetica Neue', 'Arial', sans-serif",
  font_size: '14px',
  heading_font_size: '2.25rem', // Increased from 1.75rem for better hierarchy and readability
  font_weight_normal: '400',
  font_weight_bold: '600',

  // Layout - Enhanced with more generous spacing
  border_radius: 16, // Increased from 12 for more modern look
  spacing_unit: 8,

  // Theme mode
  mode: 'light',

  // Assets
  logo_url: '',
  favicon_url: '',

  // Custom CSS for Snowflake-inspired design
  custom_css: ``,

  // Status
  is_active: false,
  status: 'inactive',
};

export default corporateProfessionalTheme;
